$(".toggle-button-menu").on("keydown", function(e) {
  const ariaExpanded = $(this).attr('aria-expanded') == "true";
  const megaMenu = $(this).parent().hasClass("contains-mega-menu");
  console.log({ e, ariaExpanded });
  if (e.keyCode == 32 || e.keyCode == 13) {
    if (ariaExpanded) {
      $(this).prev().trigger('forceclose');
      $(this).next().removeClass("menu-open");
    } else {
      $(".menu-open").removeClass("menu-open");
      $(".toggle-button-menu[aria-expanded=true]").attr("aria-expanded", false);
      $(this).prev().trigger('forceopen');
      $(this).next().addClass("menu-open");
    }
    $(this).attr('aria-expanded', ariaExpanded ? "false" : "true");
  } else {
    if (e.keyCode == 9 && ariaExpanded && megaMenu) {
      e.preventDefault();
      console.log("Some");
      $(".tier-2 a:first").focus();
    }
  }
})